import { DownsellFlowProvider } from "@/features/private-room/bookings/context/use-downsell-flow";
import { DownsellFlow } from "@/features/private-room/bookings/layouts/downsell-flow";

export const BookingDownsell = () => {
  return (
    <DownsellFlowProvider>
      <DownsellFlow />
    </DownsellFlowProvider>
  );
};
